import React, {  useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import * as analyticsActions from 'action/analyticsNew'
import * as reportActions from 'action/report'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import CommonReport from 'component/commonReport/CommonReport'
import columns from './columns'
import { isEmpty } from 'utils/validations'
import { showSpinner, hideSpinner } from 'action/spinner'
import moment from 'moment'

const INTERNAL_SERVICES = 999
const STORE_GERAL_REPORT = 25
const LDAP_GERAL_REPORT = 32
const MISSION_GERAL_REPORT = 33
const LDAP_FILTER_REPORT = 34
const MISSION_FILTER_REPORT = 35


let fetchStoreAbortController
let fetchLdapAbortController
let fetchMissionAbortController
const types = {
  store: "BRANCH",
  ldap: "LDAP",
  mission: "MISSION"

}

const regionsText =  {

  '0001': '0001 - Interlagos',
  '0002': '0002 - Ribeirão Preto',
  '0003': '0003 - Campinas D.Pedro',
  '0004': '0004 - Contagem',
  '0005': '0005 - Raposo Tavares',
  '0007': '0007 - Rio Norte',
  '0008': "0008 - L'ESPACE AD",
  '0009': '0009 - Curitiba',
  '0010': '0010 - São Caetano',
  '0011': '0011 - Rio Barra',
  '0012': '0012 - Morumbi',
  '0013': '0013 - Brasilia Sul',
  '0015': '0015 - São José Campos',
  '0016': '0016 - Ricardo Jafet',
  '0017': '0017 - Bangu',
  '0018': '0018 - Goiania',
  '0019': '0019 - Porto Alegre',
  '0020': '0020 - BH Sul',
  '0021': '0021 -  Niteroi',
  '0022': '0022 -  Anhanguera',
  '0023': '0023 - Taguatinga  ',
  '0024': '0024 - Lar Center',
  '0026': '0026 - Jacarepagua',
  '0027': '0027 - Sorocaba',
  '0028': '0028 - Brasilia Norte',
  '0029': '0029 - Uberlandia',
  '0032': '0032 - São Leopoldo',
  '0033': '0033 - Londrina',
  '0034': '0034 - Sao Jose do Rio Preto',
  '0035': '0035 - Curitiba Atuba',
  '0036': '0036 - BH Norte',
  '0038': '0038 - Fortaleza',
  '0039': '0039 - São José',
  '0041': '0041 - Anália Franco',
  '0042': '0042 - Jaguaré',
  '0044': '0044 - Campo Grande',
  '0045': '0045 - São Bernardo',
  '0046': '0046 - Tamboré',
  '0049': '0049 - Natal',
  '0050': '0050 - Maceió',
  '0055': '0055 - Taubaté  ',
  '0057': '0057 - Vitória',
  '0058': '0058 - Marginal Tiete 2',
  '0059': '0059 - Salvador',
  '0062': '0062 - Baixada Santista',
  '0063': '0063 - POA Estaleiro',
  '0065': '0065 - Express Campo Belo',
  '0067': '0067 - Guarulhos',
  '0068': '0068 - Express Pompeia',

}

const MostFuncionalityTable = ({
  auth,
  translate,
  listFiltersGlobal,
  hideSpinner,
  fetchFluxReport

}) => {

  const [formData, setFormData] = useState({})
  const [tableColumns, setTableColumns] = useState(columns)
  const [stores,setStores] = useState({})

  const [optionsButton, setOptionsButton] = useState([
    {name: 'store', active: true, },
    {name: 'ldap', active: false},
    {name: 'mission', active: false, }])

  const fields = [
    {
      type: 'branchs',
      name: 'branchIdList',
      label: translate('irc.store'),
      help_text: translate('select.one.store'),
      error_text: translate('field_must_be_filled'),
      required: true  ,
      onChangeValue: (e) => {
        setFormData({
          ...formData,
          listRegionsAndBranchs: e.target.value,
        })
      },
    },

    {
      type: 'permission_web',
      name: 'permissions',
      required: false,
      label: `${translate('totem.query.logs.modal.functionality')}`,
      help_text: translate('transferenceRequestFilterFragment.selectStatus'),
      attrs: {},
      onChangeValue: (e) => {
        setFormData({
          ...formData,
          permissionWeb: e
        })
      }

    },

    {
      type: 'ds_ldap',
      name: 'dsLdaps',
      label: translate('irc.section'),
      help_text: translate('irc.choose-section'),
      error_text: translate('field_must_be_filled'),
      required: false,
      onChangeValue: (e) => {
        console.log(e)
        setFormData({
          ...formData,
          dsLdaps: e,
        })
      },

    },

    {
      type: 'mission',
      name: 'missions',
      label: `${translate('missionMenu.addModal.field.cdMission.hint')}`,
      help_text: translate('select.one.missions'),
      error_text: translate('field_must_be_filled'),
      required: false,
      onChangeValue: (e) => {
        const dsMissions = Object.values(e).map(mission => mission.label)
        setFormData({
          ...formData,
          missions: dsMissions
        })
      }

    },

    {
      type: 'date_range',
      name: 'dtRange',
      label: translate('field.period.hint'),
      help_text: translate('kardex.field.dtRef.placeholder'),
      error_text: translate('field_must_be_filled'),
      required: true,
      onChangeValue: (e) => {
        setFormData({
          ...formData,
          dateRange: e
        })
      }
    },
  ]

  useEffect(() => {
      if(!isEmpty(listFiltersGlobal)) {
      const formInit = {}
      let branchs = []
        for (const b of listFiltersGlobal.branchs || []) {

          if (b.idBranches) {
            branchs.push(...b.idBranches)
          } else if(b.value){
            branchs.push(b.value)
          }
        }

        branchs = branchs.filter((b, p) => branchs.indexOf(b) === p)
        const dtInit = listFiltersGlobal.dtBegin
        const {dtEnd} = listFiltersGlobal
        const dtRangeGlobal = [dtInit, dtEnd]
        formInit.dtRange = dtRangeGlobal
        formInit.branchIdList = branchs
        setFormData(formInit)
      } else setStoreColumns()
  }, [])

  const setMissionColumns = () => {
    setOptionsButton(prevState => {

      setOptionsButton(prevState.map(op => op.name === 'mission' ? {...op, active: true} : {...op, active: false}))
    })

    if(Array.isArray(formData.missions) && formData.missions.length > 0 ) {
      const {missions} = formData
      mountColumns(missions.sort(), false, false)
    }

    else {
    const missionRanking = {

        label: 'Ranking missão',
        type: 'general',
        field: 'mostAccessMission',
        align: 'left',
        customWidth: 200,
        render: true,
        fixed: false,
        disableOrder: true
    }

    const accessQty = {

      label: 'Quantidade de acessos',
      type: 'general',
      field: 'mostAccessMissionQty',
      align: 'left',
      customWidth: 200,
      render: true,
      fixed: false,
      disableOrder: true
    }

    const pushColumns = {...columns}
    pushColumns.mostAccessMission = missionRanking
    pushColumns.mostAccessMissionQty = accessQty

    setTableColumns(pushColumns)
  }

  }
  const mountColumns = (newColumns, isText = false, ldapOrder = false, stores = regionsText) => {
    const pushColumns = {  ...columns}
    newColumns.filter(column => column !== 999).forEach((data) => {
      const text = stores[data] || data.toString()

      const formatData = data.toString().length < 4 ? data.toString() : data
      const obj = {
          label: isText ? stores[data] : data,
          type: 'general',
          field: formatData,
          align: 'left',
          customWidth: text.length * 10 < 140 ? 140 : text.length * 12,
          render: true,
          fixed: false,
          disableOrder: true
      }

      if(ldapOrder)
        pushColumns[`LDAP ${ data}`] = obj
      else {
        const newData = data.toString().length < 4 ? `0${data.toString()}` : data
        pushColumns[newData] = obj
      }

    })


    setTableColumns(pushColumns)
  }



  useEffect(() => {

    if(formData.defaultFilter && optionsButton.find(op => op.name === 'store').active) {
      setStoreColumns()
    }
  }, [formData])

  useEffect(() => {

    const ldapOption = optionsButton.find(op => op.name === 'ldap')

    if(Array.isArray(formData.dsLdaps) && formData.dsLdaps.length > 0 && ldapOption.active ) {
      setLdapColumns()
    }

  }, [formData])


  const setStoreColumns = async () => {


    let res;
    if(isEmpty(stores)) {

      try {
        res = await new Api(auth.user.dsToken).get(API_URL.MOUNT_STORES, {inMobile: true})
      }
      catch(_) {
        res = {data:regionsText}
      }
      setStores(res.data)
    }
    else res = {data: stores}

    setOptionsButton(optionsButton.map(op => op.name === 'store' ? {...op, active: true} : {...op, active: false}))

    if(formData.listRegionsAndBranchs && formData.listRegionsAndBranchs.length > 0) {

      const isRegions = formData.listRegionsAndBranchs.filter(data => !data.isBranch)
      const isBranch = formData.listRegionsAndBranchs.filter(data => data.isBranch)
      const regionsBranchs = new Set();

      const getBranchRegions = isRegions.map(reg => reg.idBranches)
      const totalRegionsBranchs = getBranchRegions.reduce((list, sub) => list.concat(sub), [])
      totalRegionsBranchs.forEach(r => regionsBranchs.add(r))
      isBranch.forEach(b => regionsBranchs.add(b.value))

      const regionsBranchsArray = [...regionsBranchs]
      regionsBranchs.filter(branch => branch !== INTERNAL_SERVICES)
      regionsBranchsArray.sort()
      mountColumns(regionsBranchsArray, true, false, res.data)
    } else if(Array.isArray(formData.branchIdList) && formData.branchIdList.length > 0) {
      const newData = formData.branchIdList.filter(branch => branch !== INTERNAL_SERVICES)
      mountColumns(newData.sort(), true, false, res.data)

  }

  }


  const setLdapColumns = () => {

    setOptionsButton(prevState => {

      setOptionsButton(prevState.map(op => op.name === 'ldap' ? {...op, active: true} : {...op, active: false}))
    })


    if(Array.isArray(formData.dsLdaps) && formData.dsLdaps.length > 0 ) {
      const ldaps = formData.dsLdaps.map(a => parseFloat(a))

      mountColumns(ldaps.sort(), false, true)
    }

    else {
      const LdapRanking = {

        label: 'Ranking LDAP',
        type: 'general',
        field: 'mostAccessLdap',
        align: 'left',
        customWidth: 200,
        render: true,
        fixed: false,
        disableOrder: true
      }

      const accessQty = {

        label: 'Quantidade de acessos',
        type: 'general',
        field: 'mostAcessLdapQty',
        align: 'left',
        customWidth: 200,
        render: true,
        fixed: false,
        disableOrder: true
      }

      const pushColumns = {...columns}
      pushColumns.mostAccessLdap = LdapRanking
      pushColumns.mostAccessLdapQty = accessQty

      setTableColumns(pushColumns)
    }

  }

  function onExport(callback) {

    const reportValues = {
      tpReport: 25,
    }

    const filters = {
      idBranches: formData.idBranches,
      inMobile: true,
      dtInicio: formData.dtInicio,
      dtFim: formData.dtFim,
      permissions: formData.permissions,
      missions: formData.missions,
      type: types.store,
      dsLdaps: formData.dsLdaps,
      orderDirection: formData.orderDirection.toUpperCase()
    }



    const current = optionsButton.find(op => op.active)
    switch(current.name) {
      case 'store':
        reportValues.tpReport = STORE_GERAL_REPORT
        filters.type = types.store
        fetchStoreAbortController = new AbortController();
        fetchFluxReport(auth.user.dsToken, reportValues, filters, translate, fetchStoreAbortController, true )

        break
      case 'ldap':
        reportValues.tpReport = LDAP_GERAL_REPORT
        filters.type = types.ldap
        if(filters.dsLdaps.length > 0) reportValues.tpReport = LDAP_FILTER_REPORT
        fetchLdapAbortController = new AbortController();
        fetchFluxReport(auth.user.dsToken, reportValues, filters, translate, fetchLdapAbortController, filters.missions.length > 0 )

        break
      case 'mission':
        filters.type = types.mission
        reportValues.tpReport = MISSION_GERAL_REPORT
        if(filters.missions.length > 0) reportValues.tpReport = MISSION_FILTER_REPORT
        fetchMissionAbortController = new AbortController();
        fetchFluxReport(auth.user.dsToken, reportValues, filters, translate, fetchMissionAbortController, filters.missions.length > 0 )

        break
      default:
        reportValues.tpReport = STORE_GERAL_REPORT
        filters.type = types.store
        fetchStoreAbortController = new AbortController();
        fetchFluxReport(auth.user.dsToken, reportValues, filters, translate, fetchStoreAbortController, true)

        break
    }
    callback()
  }

  const onMessage = () => {

  }
  const onClose = () =>  hideSpinner()
  const onError = () => {hideSpinner()}

  const callBranchs = (params) => {
    const abortController = new AbortController()



    return new Api(auth.user.dsToken)
    .eventSourceStream(API_URL.ANALYTICS_LIST_ACCESSES_V2, params, null, abortController, onMessage, onClose, onError)
    .then((response) => {

      hideSpinner()
      return response
    })
    .catch(() => hideSpinner())
  }

  const callDataTable = async (params, column) => {
    const dtInicio = moment(params.dtStart).format("DD/MM/YYYY")
    const dtFim = moment(params.dtEnd).format("DD/MM/YYYY")
    params.dtInicio = dtInicio
    params.dtFim = dtFim
    params.inMobile = true
    params.idBranches = params.branchIdList.filter(branchs => branchs !== INTERNAL_SERVICES)
    params.type = types[column]
    if(params.permissions == null) params.permissions = []
    if(!params.dsLdaps) params.dsLdaps = []
    if(!params.missions) params.missions = []
    params.limit = null

    const response = await callBranchs(params)
    const data  = response.data.mostAccessedDetails
    return data
  }

  const setInTable = ( res,setResponseInTable) => {

      const dataTable = Array.isArray(res) && res.length > 0 ? res : []
      setResponseInTable({ total: 1, data: dataTable})

  }

  async function onSubmit(submitData, setResponseInTable, typeColumn) {
    const formattedValues = {
      ...submitData,
      dtEnd: submitData.dtRange ? submitData.dtRange[1] : '',
      dtStart: submitData.dtRange ? submitData.dtRange[0] : '',

    }

    delete formattedValues.dtRange
      setFormData(formattedValues)


      switch(typeColumn) {
        case 'store':
          setStoreColumns()
          const fetchStore = callDataTable(formattedValues, typeColumn)
          fetchStore.then((res => setInTable(res, setResponseInTable)))
          break
        case 'mission':
          setMissionColumns()
          const fetchMission = callDataTable(formattedValues, typeColumn)
          fetchMission.then((res => setInTable(res, setResponseInTable)))
          break

        case 'ldap':
          setLdapColumns()
          const fetchLdap = callDataTable(formattedValues, typeColumn)
          fetchLdap.then((res => setInTable(res, setResponseInTable)))
          break
          default:
            const fetchDefault = callDataTable(formattedValues, typeColumn)
            fetchDefault.then((res => setInTable(res, setResponseInTable)))
            break
      }

    }
  return (
    <CommonReport
      isWeb={false}
      analyticsDetails={true}
      title={`${translate('analytics.title')} - ${translate('analytics.mostAccessedMobile')}`}
      onExport={onExport}
      onSubmit={onSubmit}
      submitOnRender={true}
      columns={tableColumns}
      showTable
      fields={fields}
      user={auth.user}
      limit={10}
      translate={translate}
      emptyReportMsg='no.data.found'
      backToVision
      order
      defaultOrder={'funcionality'}
      setMissionColumns={setMissionColumns}
      setStoreColumns={setStoreColumns}
      emptyBranchs={isEmpty(listFiltersGlobal)}

    />
  )
}
MostFuncionalityTable.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  current: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  demarcateReportList: PropTypes.array.isRequired,
  fetch: PropTypes.func.isRequired,
  fetchReports: PropTypes.func.isRequired,
  fetchFluxReport: PropTypes.func.isRequired,
  fetchFuncionalitiesDetails: PropTypes.func.isRequired,
  funcionalityMostAccess: PropTypes.object,
  listFuncionalitiesDetails: PropTypes.arrayOf(Object),
  listFiltersGlobal: PropTypes.object,
  fetchListMostAccessedBranchs: PropTypes.func,
  hideSpinner: PropTypes.func,
  showSpinner: PropTypes.func,

}

/* istanbul ignore next */
const mapStateToProps = ({ delimitReportReducer, paginateReducer, analyticsReducer }) => ({
  demarcateReportList: delimitReportReducer.list,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
  analyticsNew: analyticsReducer,
  listMostAccess: analyticsReducer.listMostAccess.record,
  listDevicesUpdate: analyticsReducer.devices.record,
  listUsersAccess: analyticsReducer.users.record,
  listFuncionalitiesDetails: analyticsReducer.listFuncionalitiesDetails.record,
  listFiltersGlobal: analyticsReducer.listFiltersGlobal.record,
  funcionalityMostAccess: analyticsReducer.funcionalityMostAccess.record
})

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {

      ...analyticsActions,
      ...reportActions,
      showSpinner,
      hideSpinner
    },
    dispatch
  )
}

const MostFuncionalityTableTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(MostFuncionalityTable)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MostFuncionalityTableTranslated)

export { MostFuncionalityTable }
